import { createSlice } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

const initialState: TDefaultStoreDTO = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: 'createdAt',
	searchValue: '',
};

const assetsRentOutgoingRequests = createSlice({
	name: 'assetsRentOutgoingRequests',
	initialState,
	reducers: {
		...defaultStoreDTO,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
} = assetsRentOutgoingRequests.actions;

export default assetsRentOutgoingRequests.reducer;
